import type { RouteObject } from "react-router";

import { InvoiceListPage } from "./invoice-list-page.js";
import { InvoiceMenuPage } from "./invoice-menu-page.js";
import { InvoicePage } from "./invoice-page.js";

/**
 * 請求書。<b>足したら paths/invoices.json にも足す。</b>
 *
 * <b>今のアプリが作る URL をすべて開ける</b>——<c>/TenantInvoice?tenantId=</c>（既定の Index）と、
 * id がパスに載る <c>/TenantInvoice/Show/202601?tenantId=</c>。メールや履歴に残った URL を切らない。
 * 請求書のメニュー（<c>/TenantInvoice/Menu</c>）はポータルで足した画面で、今の URL と重ならない。
 */
export const invoiceRoutes: RouteObject[] = [
    { path: "/TenantInvoice", element: <InvoiceListPage /> },
    { path: "/TenantInvoice/Index", element: <InvoiceListPage /> },
    { path: "/TenantInvoice/Menu", element: <InvoiceMenuPage /> },
    { path: "/TenantInvoice/Show", element: <InvoicePage /> },
    { path: "/TenantInvoice/Show/:id", element: <InvoicePage /> },
];
